import {createSelector} from 'reselect';

import layoutService from '../../services/layoutService';

const selectGlobal = (state) => state.global;

const selectIsAppLoading = createSelector(selectGlobal, (globalState) => globalState.isAppLoading);

const selectIsConfigInitialized = createSelector(selectGlobal, (globalState) => globalState.isConfigInitialized);

const selectLoaders = createSelector(selectGlobal, (globalState) => globalState.loaders);

const makeSelectIsLoaderVisible = (loaderName) =>
    createSelector(selectLoaders, (loaders) => {
        const loader = loaders?.filter(({name}) => name === loaderName);

        return loader?.length;
    });

const selectNotifications = createSelector(selectGlobal, (globalState) => globalState.notifications);

const selectIsHolderRegisterFailed = createSelector(selectGlobal, (globalState) => globalState.isHolderRegisterFailed);

const selectIsDoubleRegistration = createSelector(selectGlobal, (globalState) => globalState.isDoubleRegistration);

const selectIsSkipRegistration = createSelector(selectGlobal, (globalState) => globalState.isSkipRegistration);

const selectIsRegistrationWas = createSelector(selectGlobal, (globalState) => globalState.isRegistrationWas);

const selectLayoutType = createSelector(selectGlobal, (globalState) => globalState.layout);

const selectIsMobileLayout = createSelector(selectLayoutType, (layout) => layoutService.isMobileLayout(layout));

const selectIsDesktopLayout = createSelector(selectLayoutType, (layout) => layoutService.isDesktopLayout(layout));

const selectIsSmLayout = createSelector(selectLayoutType, (layout) => layoutService.isSmLayout(layout));

const selectIsNetworkOnline = createSelector(selectGlobal, (globalState) => globalState.isNetworkOnline);

const selectIsReconnectGuideEnabled = createSelector(
    selectGlobal,
    (globalState) => globalState.isReconnectGuideEnabled
);

const selectIsStartAutoSync = createSelector(selectGlobal, (globalState) => globalState.isStartAutoSync);

const selectIsBluetoothAvailable = createSelector(selectGlobal, (globalState) => globalState.isBluetoothAvailable);

const selectIsScpCheckInProgress = createSelector(selectGlobal, (globalState) => globalState.isScpCheckInProgress);

const selectIsFwuPage = createSelector(selectGlobal, (globalState) => globalState.isFwuPage);

const selectErrorPageType = createSelector(selectGlobal, (globalState) => globalState.errorPageType);

const selectWasShownLeviaGetStartedNotification = createSelector(
    selectGlobal,
    (globalState) => globalState.wasShownLeviaGetStartedNotification
);

const selectIsAemFlexBatteryWarningVisible = createSelector(
    selectGlobal,
    (globalState) => globalState.isAemFlexBatteryWarningVisible
);

const selectNavigationTarget = createSelector(selectGlobal, (globalState) => globalState.navigationTarget);
const selectDoesNavigationTargetExist = createSelector(
    selectNavigationTarget,
    (navigationTarget) => !!navigationTarget?.target
);

export {
    makeSelectIsLoaderVisible,
    selectDoesNavigationTargetExist,
    selectErrorPageType,
    selectIsAemFlexBatteryWarningVisible,
    selectIsAppLoading,
    selectIsBluetoothAvailable,
    selectIsConfigInitialized,
    selectIsDesktopLayout,
    selectIsDoubleRegistration,
    selectIsFwuPage,
    selectIsHolderRegisterFailed,
    selectIsMobileLayout,
    selectIsNetworkOnline,
    selectIsReconnectGuideEnabled,
    selectIsRegistrationWas,
    selectIsScpCheckInProgress,
    selectIsSkipRegistration,
    selectIsSmLayout,
    selectIsStartAutoSync,
    selectLayoutType,
    selectLoaders,
    selectNavigationTarget,
    selectNotifications,
    selectWasShownLeviaGetStartedNotification,
};
